import { render, staticRenderFns } from "./Animalvalues.vue?vue&type=template&id=0ce92140&"
import script from "./Animalvalues.vue?vue&type=script&lang=js&"
export * from "./Animalvalues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports